import { IconActionChevronLeft12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles/backArrow.css';

interface IBackArrowProps {
  onClick(): void;
}

export function BackArrow({ onClick }: IBackArrowProps) {
  return (
    <div className={styles['back_arrow']} data-testid="BackArrow">
      <IconActionChevronLeft12 onClick={onClick} />
    </div>
  );
}
